import React from 'react';
import PageHeader from 'components/PageHeader';
import ContainerLayout from 'layouts/ContainerLayout';
import Contacts from 'pages/Contact/Contacts';
import EmailForm from 'pages/Contact/EmailForm';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

const Contact: React.FunctionComponent = () => {
  const { t } = useTranslation();

  return (
    <ContainerLayout>
      <Box sx={{ textAlign: 'center' }}>
        <PageHeader>{t('contacts.title')}</PageHeader>
        <EmailForm />
        <Contacts />
      </Box>
    </ContainerLayout>
  );
};

export default Contact;
